// time-ago.util.ts
import { TranslateService } from '@ngx-translate/core';

export class CustomDateUtils {

    static timeAgo(isoDate: string, translate: TranslateService): string {

        if (!isoDate) return '';

        const dateTime = new Date(isoDate);
        const now = new Date();

        const diffMs = now.getTime() - dateTime.getTime();

        const diffSeconds = Math.floor(diffMs / 1000);
        const diffMinutes = Math.floor(diffSeconds / 60);
        const diffHours = Math.floor(diffMinutes / 60);
        const diffDays = Math.floor(diffHours / 24);

        if (diffSeconds < 60) {
            return translate.instant('time_just_now');
        }

        if (diffMinutes < 60) {
            return translate.instant('time_minutes_ago', {
                count: diffMinutes
            });
        }

        if (diffHours < 24) {
            return translate.instant('time_hours_ago', {
                count: diffHours
            });
        }

        if (diffDays < 7) {
            return translate.instant('time_days_ago', {
                count: diffDays
            });
        }

        if (diffDays < 30) {
            const weeks = Math.floor(diffDays / 7);
            return translate.instant('time_weeks_ago', {
                count: weeks
            });
        }

        if (diffDays < 365) {
            const months = Math.floor(diffDays / 30);
            return translate.instant('time_months_ago', {
                count: months
            });
        }

        const years = Math.floor(diffDays / 365);
        return translate.instant('time_years_ago', {
            count: years
        });
    }
}
